import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";

const PrivateWorkPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <div className="relative bg-void min-h-screen">
      <Navbar onNavigate={(k) => (k === "work" ? navigate("/work") : navigate(`/#${k}`))} />

      <main
        data-testid="private-work-page"
        className="mx-auto flex min-h-screen max-w-3xl items-center justify-center px-6"
      >
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-display font-medium text-center text-xl md:text-2xl lg:text-3xl text-bone leading-relaxed"
        >
          I cannot share some of my work due to privacy policies; contact me at{" "}
          <a
            href="mailto:hello@polatpala.com"
            className="underline decoration-navy-ink/60 underline-offset-[6px] hover:text-navy-ink transition-colors"
          >
            hello@polatpala.com
          </a>
        </motion.p>
      </main>
    </div>
  );
};

export default PrivateWorkPage;
